import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/done-rounded-white.svg'
import _imports_1 from '@/assets/error-rounded.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c8d2ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "div-alert-main" }
const _hoisted_2 = { class: "div-alert-frame" }
const _hoisted_3 = { id: "alert-title-h3" }
const _hoisted_4 = { class: "div-alert-subframe" }
const _hoisted_5 = {
  key: 0,
  id: "icon-success"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "img-success",
  src: _imports_0
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  id: "icon-error"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "img-error",
  src: _imports_1
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.successCase)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
        _createElementVNode("b", { innerHTML: _ctx.text }, null, 8, _hoisted_11),
        (_ctx.subtext)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              innerHTML: _ctx.subtext,
              class: "body"
            }, null, 8, _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "alert-continue-button",
          class: "buttonContinue",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleContinue()))
        }, _toDisplayString(_ctx.button), 1)
      ])
    ])
  ]))
}